import * as app from './app';
import * as alarms from './alarms';
import * as devices from './devices';
import * as deviceGroups from './deviceGroups';
import * as monitoring from './monitoring';
import * as policies from './policies';
import * as reports from './reports';
import * as server from './server';
import * as shell from './shell';

// tslint:disable-next-line:no-default-export
export default {
    app,
    alarms,
    devices,
    deviceGroups,
    monitoring,
    policies,
    reports,
    server,
    shell,
};


// WEBPACK FOOTER //
// ./src/sagas/index.ts